{
  "hasNewsletter": true,
  "hasPromotions": true,
  "freeShippingValue": 69.9,
  "klarnaMinValue": 105,
  "klarnaInstallments": 3,
  "metacolorReferences": {
    "Azul grisáceo": "#aabdd8",
    "Blanco": "#fff",
    "Negro": "#000",
    "Negro cósmico": "#000",
    "Negro mate": "#000",
    "Rosa": "#FFC0CB",
    "Azul glaciar": "b6e1f7",
    "Lavanda": "#ded2e7",
    "Violeta": "#5b0166",
    "Agua marina": "#95b8da",
    "Azul": "c6e2ff",
    "Negro ónice": "#000",
    "Rosa cuarzo": "#FFC5ED",
    "Blanco alabastro": "#fff",
    "Violeta ametrina": "#5B0166",
    "Negro lava": "#000",
    "Verde Bosque": "#9dbe8f"
  },
  "menu": {
    "items": []
  },
  "homeSlideshow": {
    "items": [
      {
        "btnTitle": "",
        "desc": "",
        "id": "",
        "image": "",
        "link": "",
        "refID": "",
        "title": "",
        "type": "",
        "visible": true
      }
    ]
  },
  "homeModules": [
    {
      "abtest": false,
      "count": 0,
      "link": "",
      "order": -1,
      "prodsFilter": "",
      "randomize": false,
      "title": "",
      "titleMerchant": "",
      "visible": true
    }
  ],
  "products": [
    {
      "categories": [
        {
          "categoryID": "",
          "externalID": "",
          "categoryName": "",
          "parent_cat_id": ""
        }
      ],
      "country": "",
      "descriptions": [
        {
          "lang": "",
          "title": "",
          "short": "",
          "long": "",
          "seo": {
            "title": "",
            "meta_description": "",
            "url": ""
          },
          "sections": [
            {
              "i18nTitleTag": "",
              "content": ""
            }
          ]
        }
      ],
      "hiddenPrice": false,
      "id": "",
      "imageUrl": "",
      "price": {
        "country": "",
        "currency": "",
        "currencies": [
          {
            "currency": "",
            "prices": [
              {
                "recommendedPrice": "",
                "unitCost": "",
                "licence": "",
                "price": 0,
                "oldPrice": 0
              }
            ]
          }
        ],
        "includesTaxes": true,
        "prices": [
          {
            "licence": "",
            "price": 0,
            "crossed_price": 0
          }
        ],
        "taxType": ""
      },
      "gallery": [
        {
          "name": "",
          "nameAlt": "",
          "type": "",
          "url": "",
          "visible": true
        }
      ],
      "state": "",
      "stock": {
        "lowStockAlert": 0,
        "policy": "",
        "stock": 0
      },
      "type": ""
    }
  ]
}